import { Injectable } from '@angular/core';
import { MenuItemGroup } from '@app/interfaces';
import { MenuService } from '@app/services/menu/menu.service';

const menu: MenuItemGroup = [
    {
        key: 'self-serve.homeMenuItems.quickstart',
        link: ['/company-onboarding'],
        routerLinkExact: true,
    },
    {
        key: 'self-serve.homeMenuItems.inbox',
        link: ['/company-onboarding'],
        routerLinkExact: true,
        queryParams: { view: 'inbox' },
    },
];
@Injectable({
    providedIn: 'root',
})
export class QuickstartHomeMenuService extends MenuService {
    setBaseMenu(): void {
        this.baseMenu = menu;
    }
}
